
import '../App.css';

function NavBar() {

    return (
        <body>
            <ul>
                <li><a href="#/">Home</a></li>
                <li><a href="#/properties">Properties</a></li>
                <li><a href="#/residentmanager">Resident Manager</a></li>
                <li><a href="#/propertiesrms">Properties_RMs</a></li>
                <li><a href="#/units">Units</a></li>
                <li><a href="#/tenants">Tenants</a></li>
            </ul>
        </body>
        
        
    );
}

export default NavBar;